import { createDialogWithIdStore } from '../createDialogWithIdStore';

export const useThreadInfoDialog = createDialogWithIdStore<number>();
